import Api from '../../../shared/Api';
import { IStylingUser, IMetaData } from '../Entities';

class StylingUsersApi {
    static getStylingUsers(): any {
        return new Api().get('/views/stylinguser');
    }

    static getStylingUser(id: number): any {
        return new Api().get(`/views/stylinguser/${id}`);
    }

    static createStylingUser(data: IStylingUser): any {
        return new Api().post(`/views/stylinguser/`, data);
    }

    static updateStylingUser(data: IStylingUser): Promise<any> {
        return new Api().put(`/views/stylinguser/`, data);
    }

    static deleteStylingUser(id: number): any {
        return new Api().delete(`/views/stylinguser/${id}`);
    }

    static loadMetaData(): Promise<IMetaData> {
        return new Api().get(`/views/stylinguser/meta`);
    }
}

export default StylingUsersApi;
